(() => {
  if (window.ppChoicesLoaded) return;
  window.ppChoicesLoaded = true;
  const normalize = value => String(value || '').trim().toLocaleLowerCase();
  const list = value => { try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : [parsed]; } catch { return []; } };
  const cache = new Map();
  const fetchSection = async url => {
    if (!cache.has(url.href)) cache.set(url.href, fetch(url, {credentials:'same-origin'}).then(response => { if (!response.ok) throw Error('section'); return response.text(); }).catch(error => {cache.delete(url.href);throw error;}));
    return new DOMParser().parseFromString(await cache.get(url.href), 'text/html');
  };
  class ColourAlternatives extends HTMLElement {
    connectedCallback() {
      const anchor=this.closest('.shopify-section') || this.parentElement;
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) return this.load();
      this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'400px'});
      this.observer.observe(anchor);
    }
    async load() {
      const generation = this.generation = (this.generation || 0) + 1;
      if (!this.dataset.source) return;
      const url = new URL(this.dataset.source, location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.set('section_id','pp-colour-candidates');
      try {
        const source = await fetchSection(url);
        const filters = JSON.parse(source.querySelector('[data-pp-filter-map]')?.textContent || '[]');
        const colours = list(this.dataset.colours).map(normalize);
        const colourFilter = filters.find(filter => /kleur|colou?r/i.test(filter.label) && !/nummer/i.test(filter.label) && filter.values.some(value => colours.includes(normalize(value.label))));
        if (!colourFilter) return;
        colourFilter.values.filter(value => colours.includes(normalize(value.label))).forEach(value => url.searchParams.append(value.param || colourFilter.param, value.value));
        const brandFilter = filters.find(filter => /merk|brand|vendor/i.test(filter.label));
        const brand = brandFilter?.values.find(value => normalize(value.label) === normalize(this.dataset.vendor));
        if (brand) url.searchParams.set(brand.param || brandFilter.param,brand.value);
        const filtered = await fetchSection(url);
        const candidates = filtered.querySelector('[data-pp-colour-candidates]')?.content.querySelectorAll('[data-candidate]') || [];
        const families = new Map();
        for (const candidate of candidates) {
          const data = candidate.dataset;
          if (normalize(data.vendor) !== normalize(this.dataset.vendor) || data.family === this.dataset.family) continue;
          if (this.dataset.kind && normalize(data.kind) !== normalize(this.dataset.kind)) continue;
          if (this.dataset.series && data.series === this.dataset.series) continue;
          if (!list(data.colours).some(colour => colours.includes(normalize(colour)))) continue;
          const existing = families.get(data.family);
          if (!existing || normalize(data.volume) === normalize(this.dataset.volume)) families.set(data.family,candidate);
        }
        const cards = [...families.values()].slice(0,Number(this.dataset.limit) || 8).map(template => template.content.querySelector('[data-pp-card]')?.cloneNode(true)).filter(Boolean);
        if (!cards.length || !this.isConnected || generation !== this.generation) return;
        this.querySelector('[data-pp-track]').replaceChildren(...cards);
        url.searchParams.delete('section_id');this.querySelector('[data-colour-all]').href=url.href;
        this.hidden=false;
        document.dispatchEvent(new CustomEvent('pp:content:updated',{detail:{root:this}}));
      } catch {}
    }
    disconnectedCallback(){this.observer?.disconnect();this.generation=(this.generation || 0)+1;}
  }
  if (!customElements.get('pp-colour-alternatives')) customElements.define('pp-colour-alternatives',ColourAlternatives);
  const initialize = root => root.querySelectorAll('[data-pp-share]').forEach(button => {
    if (!navigator.share && !navigator.clipboard) return;
    if (button.dataset.ready) return;
    button.dataset.ready='true';button.hidden=false;
    button.addEventListener('click', async () => {
      const url=new URL(location.href);url.search='';url.hash='';
      try {if(navigator.share) await navigator.share({title:button.dataset.title,url:url.href});else {await navigator.clipboard.writeText(url.href);button.parentElement.querySelector('[data-pp-share-status]').textContent=button.dataset.copied;}} catch {}
    });
  });
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

